<footer>
    <div class="footer_dark">
        <div class="container">
            <div class="footer_dark__top">
                <div class="row" *ngIf="main_menu">
                    <div class="col-lg-2-7 col-12" *ngFor="let menu of main_menu.childs; let i=index">
                        <section [ngClass]="{'active': activeIndex === i}">
                            <a *ngIf="menu.url && menu.url.trim()" 
                               href="{{menu.url}}" 
                               [attr.title]="menu.title" 
                               (click)="onMenuClick($event, i, menu)">
                              <h4 [attr.title]="menu.title">
                                {{menu.title}}
                              </h4>
                            </a>
                            <span *ngIf="!menu.url || !menu.url.trim()" 
                                  [attr.title]="menu.title"
                                  class="no-link"
                                  (click)="onMenuClick($event, i, menu)">
                              <h4 [attr.title]="menu.title">
                                {{menu.title}}
                              </h4>
                            </span>
                            <div class="footer_dark__top__menu">
                              <ul>
                                <li *ngFor="let smenu of menu.childs">
                                  <a *ngIf="smenu.url && smenu.url.trim()" 
                                     href="{{smenu.url}}" 
                                     [attr.title]="smenu.title" 
                                     (click)="goLink($event, smenu.url, smenu.title, menu.title)">
                                    {{smenu.title}}
                                  </a>
                                  <span *ngIf="!smenu.url || !smenu.url.trim()" 
                                        [attr.title]="smenu.title"
                                        class="no-link">
                                    {{smenu.title}}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </section>
                          
                    </div>
                </div>
            </div>
            <div class="footer_dark__bottom">
                <div class="row">
                    <div class="col-lg-4 col-md-12">
                        <address>
                            <h4>{{layout_text.footer_adres_baslik}}</h4>
                            <ul>
                                <li>{{layout_text.footer_adres_text}}</li>
                                <li><a href="#" [outerHTML]="layout_text.footer_adres_tel"></a></li>
                                <li>{{layout_text.footer_adres_fax}}</li>
                            </ul>
                        </address>
                    </div>
                    <div class="col-lg-8 col-md-12">
                        <div class="linkedin-wrapper">
                            <div class="linkedinContainer" style="min-height: 28px;">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer_light">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer_light__menu">
                        <ul *ngIf="bottom_menu">
                            <li *ngFor="let menu of bottom_menu.childs">
                                <a *ngIf="menu.url && menu.url.trim()" 
                                   href="{{menu.url}}" 
                                   [attr.title]="menu.title" 
                                   (click)="goLink($event, menu.url, menu.title, 'Alt Menü')">
                                    {{menu.title}}
                                </a>
                                <span *ngIf="!menu.url || !menu.url.trim()" 
                                      [attr.title]="menu.title"
                                      class="no-link">
                                    {{menu.title}}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="footer_light__bottom">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <figure>
                                    <img loading="lazy" width="239" height="60" src="/assets/images/content/calik-logo.png" alt="" style="width: 239px; height: 60px;">
                                </figure>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <p>{{ lang === 'tr' ? 'Her hakkı Aktif Bank\'a aittir. © ' + currentYear : 'All rights reserved. © ' + currentYear }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
